import { render } from "./VueTextarea.vue?vue&type=template&id=d58ace10&scoped=true"
import script from "./VueTextarea.vue?vue&type=script&lang=js"
export * from "./VueTextarea.vue?vue&type=script&lang=js"

import "./VueTextarea.vue?vue&type=style&index=0&id=d58ace10&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d58ace10"]])

export default __exports__